var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8","height":"16","viewBox":"0 0 8 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7.70833 0L0 7.70833L7.70833 15.4167V0Z","fill":"#F2F2F2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }